import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import Particle from "../Particle";
import { Link } from "react-router-dom";

// import VerticalNavBar from "../VerticalNavBar";
import API from "../../utils/api";
import SkillInsightCard from "./SkillInsightCard";
import SkillSearch from "./SkillSearch";

// const getEmojiLabel = (rating) => {
//   if (rating >= 4.5) return "🌟 Mastery";
//   if (rating >= 4.0) return "💪 Pro Level";
//   if (rating >= 3.0) return "🚀 Getting There";
//   if (rating >= 2.0) return "🔍 Exploring";
//   return "🔰 Beginner Zone";
// };

function Skills({ authenticated }) {
  const [skills, setSkills] = useState([]);
  const [allSkills, setAllSkills] = useState([]); // unfiltered data

  useEffect(() => {
    // Load initial data on component mount
    API.get("/api/skills")
      .then((res) => res.data)
      .then((response) => {
        setSkills(response.skills);
        setAllSkills(response.skills);
        console.log("Initial data fetched successfully:", response.skills);
      })
      .catch((error) => {
        console.error("There was an error fetching the initial data!", error);
      });
  }, []);

  // Search filter (by skill name or domain)
  const searchKeyword = (keyword) => {
    if (!keyword) {
      setSkills(allSkills);
      return;
    }

    const filteredSkills = allSkills.filter(
      (skill) =>
        (skill.domain &&
          skill.domain.toLowerCase().includes(keyword.toLowerCase())) ||
        (skill.name && skill.name.toLowerCase().includes(keyword.toLowerCase()))
    );

    setSkills(filteredSkills);
  };

  // Filter skills by rating bands (using rating scale 0-10)
  const filterSkills = (filterType) => {
    if (filterType === "all") {
      setSkills(allSkills);
      return;
    }

    const filtered = allSkills.filter((skill) => {
      const rating = skill.rating || 0;

      switch (filterType) {
        case "mastery":
          return rating >= 9.0;
        case "pro":
          return rating >= 7.0 && rating < 9.0;
        case "getting":
          return rating >= 5.0 && rating < 7.0;
        case "exploring":
          return rating >= 2.5 && rating < 5.0;
        default:
          return true;
      }
    });

    setSkills(filtered);
  };

  // Group and sort skills by domain and rating
  const groupedAndSortedSkills = React.useMemo(() => {
    const grouped = skills.reduce((acc, skill) => {
      const domain = skill.domain || "Unknown Domain";
      if (!acc[domain]) acc[domain] = [];
      acc[domain].push(skill);
      return acc;
    }, {});

    Object.keys(grouped).forEach((domain) => {
      grouped[domain].sort((a, b) => b.rating - a.rating);
    });

    return grouped;
  }, [skills]);

  return (
    <>
      <Container>
        <Particle />
      </Container>
      <Container fluid className="revision-section">
        <h1>🚀 Applied Skills in Action</h1>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <div
            style={{
              fontSize: "0.85rem",
              fontWeight: "normal",
              color: "#666",
              background: "#f9f9f9",
              padding: "4px 10px",
              borderRadius: "6px",
              alignSelf: "flex-end",
              marginBottom: "0.5rem",
              marginRight: "1rem",
            }}
          >
            <span style={{ color: "#6a0dad ", fontWeight: "bold" }}>Click</span>{" "}
            on each skill to know more.{" "}
            <span style={{ color: "#8e44ad ", fontWeight: "bold" }}>
              Ratings
            </span>{" "}
            are generated by a rating Agent.
          </div>
        </div>
        <SkillSearch
          searchKeyword={searchKeyword}
          filterSkills={filterSkills}
        />
        {Object.entries(groupedAndSortedSkills).map(
          ([domain, skillsInDomain]) => (
            <div key={domain} style={{ marginBottom: "2rem" }}>
              <h4>{domain}</h4>
              {skillsInDomain.map((skill, idx) => (
                <SkillInsightCard
                  key={`${domain}-${skill.name}-${idx}`}
                  skill={skill}
                  authenticated={authenticated}
                />
              ))}
            </div>
          )
        )}
      </Container>

      <Link to="/courses" className="course-button">
        🎓 See My Learning Journey
      </Link>
    </>
  );
}

export default Skills;
